<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="年份">{{ form.fiscalYearMonth }}</a-descriptions-item>
            <a-descriptions-item label="总资产(万元)">{{form.totalAssets}}</a-descriptions-item>
            <a-descriptions-item label="总负债(万元)">{{form.totalLiability}}</a-descriptions-item>
            <a-descriptions-item label="净利润(万元)">{{form.retainedProfits}}</a-descriptions-item>
            <a-descriptions-item label="缴税总额">{{form.totalTax}}</a-descriptions-item>
            <a-descriptions-item label="营业收入(万元)">{{form.operatingIncome}}</a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
import { formMixin } from "@/mixins";

export default {
    name: "Detail",
    mixins: [formMixin],
    components:{},
    data() {
        return {
            form: {
                id: null,
                fiscalYearMonth: null,
                totalAssets: null,
                totalLiability: null,
                retainedProfits: null,
                totalTax: null,
                operatingIncome: null
            },
        }
    },
    methods:{
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>

<style scoped lang="less">

</style>
